import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Group from '../Group/Group';
import UnitInput from './UnitInput';

const WEIGHT_UNITS = [{
  factor: 0.001,
  unit: 'gram',
  many: 'grams',
}, {
  factor: 1,
  unit: 'kg',
}, {
  factor: 1000,
  unit: 'ton',
  many: 'tons',
},];


class UnitInputExample extends Component {

  state = {
    label: 'Value is a string',
    value: '6 months',
    units: UnitInput.PERIOD_DAYS_WEEKS_MONTHS_YEARS,
    periodValue: 86400 * 365,
    weightValue: 1,
    weightUnit: 'kg',
  };

  onChange = e => this.setState({ value: e.target.valueString });

  onChangePeriod = e => this.setState({
    periodValue: e.target.value,
    periodUnit: e.target.unit,
  });

  onChangeWeight = e => this.setState({
    weightValue: e.target.value,
    weightUnit: e.target.unit,
  });

  onChangeProps = e => this.setState(e.target.value);

  render() {
    const {periodValue, periodUnit, weightValue, weightUnit, ...rest } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChangeProps} defaultProps={UnitInput.defaultProps} propTypes={UnitInput.propTypes} propValues={this.state}>
          <Tip>These props will only affect the first input field.</Tip>
        </Properties>
        <Group>
          <UnitInput {...rest} onChange={this.onChange}/>
          <UnitInput units={UnitInput.PERIOD_DAYS_WEEKS_MONTHS_YEARS} value={periodValue} unit={periodUnit} label="Converting period" onChange={this.onChangePeriod} convert rounded/>
          <UnitInput units={WEIGHT_UNITS} value={weightValue} unit={weightUnit} onChange={this.onChangeWeight} label="Converting units" defaultUnitIndex={1} convert/>
        </Group>
        <SourceCode querySelector=".core-unit-input"/>
      </Example>
    );
  }

}

UnitInputExample.tags = 'date period convert';

export default UnitInputExample;
